import type { ParseError } from "/npm/effect@3.14.1/ParseResult/+esm";

import * as Effect from "/npm/effect@3.14.1/Effect/+esm";
import * as Schema from "/npm/effect@3.14.1/Schema/+esm";
import { ID, GID, Type } from "/npm/@brytdesigns/shopify-utils@1.2.10/dist/jsdelivr/effect/Resource/schema.js";

type FormatOptions<T extends ID, R extends Type> = {
  id: T;
  type: R;
};

export const format = <const T extends ID, const R extends Type>({
  id,
  type,
}: FormatOptions<T, R>): Effect.Effect<
  `gid://shopify/${R}/${T}`,
  ParseError,
  never
> =>
  Effect.gen(function* () {
    const actualId = yield* Schema.decode(ID)(id);
    const actualType = yield* Schema.decode(Type)(type);
    return `gid://shopify/${actualType}/${actualId}` as `gid://shopify/${R}/${T}`;
  });

export const parse = (
  input: string,
): Effect.Effect<string, ParseError, never> => Schema.decode(GID)(input);
